export function getDeviceId() {
  let id = localStorage.getItem("asml_device_id");
  if (!id) {
    id = "web-" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    localStorage.setItem("asml_device_id", id);
  }
  return id;
}
